import { render, staticRenderFns } from "./PzButton.vue?vue&type=template&id=3fd8136a&"
import script from "./PzButton.vue?vue&type=script&lang=js&"
export * from "./PzButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports